import { Music, UtensilsCrossed, Sparkles } from "lucide-react";
import BackToMore from "../components/BackToMore";

// AI in Secondary Education computer labs in numerical order
const AI_LABS = [124, 252, 281, 1146, 1171, 1174, 1178, 1180].map((n) => ({
  number: n,
  kind: "Computer Lab",
  session: "AI in Secondary Education",
}));

// AI Prompting & MagicSchool AI rooms in numerical order
const AI_PROMPTING_ROOMS = [1117, 1125, 1126, 1129, 1130, 1131, 1132, 1133].map(
  (n) => ({
    number: n,
    kind: "Room",
    session: "AI Prompting & MagicSchool AI",
  }),
);

// Schoology GEMS rooms in numerical order
const SCHOOLOGY_ROOMS = [120, 121, 142, 144, 145, 1145, 1149, 1150].map((n) => ({
  number: n,
  kind: "Room",
  session: "Schoology GEMS",
}));

// All session rooms grouped by course title (AI Secondary, AI Prompting, Schoology)
const SESSION_ROOMS = [...AI_LABS, ...AI_PROMPTING_ROOMS, ...SCHOOLOGY_ROOMS];

const FEATURED = [
  {
    name: "Auditorium - Room 1100",
    desc: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment (7:30-8:30 AM)\nKeynote: Richard Culatta (8:30–9:15 AM)",
    Icon: Music,
    bg: "#145261",
    iconColor: "#FFFFFF",
  },
  {
    name: "Cafeteria - Room 153",
    desc: "Lunch (11:45 AM–1:00 PM)",
    Icon: UtensilsCrossed,
    bg: "#F6B829",
    iconColor: "#092936",
  },
];

const SESSION_ROOM_ITEMS = SESSION_ROOMS.map((r) => ({
  name: `${r.kind} ${r.number}`,
  desc: r.session,
  Icon: Sparkles,
  bg: "#541011",
  iconColor: "#FFFFFF",
}));

const LOCATIONS = [...FEATURED, ...SESSION_ROOM_ITEMS];

export default function Locations() {
  return (
    <div className="p-4 pb-10" data-testid="locations-page">
      <BackToMore />
      <h2
        className="font-extrabold mb-1"
        style={{ color: "#092936", fontSize: 22 }}
      >
        Where to Go - Parker High School
      </h2>
      <p className="mb-5" style={{ color: "#5A6A72", fontSize: 14 }}>
        Every room and the sessions held there.
      </p>

      {LOCATIONS.map((l) => {
        const Icon = l.Icon;
        return (
          <div
            key={l.name}
            className="flex items-center bg-white rounded-[14px] p-3.5 mb-3 border"
            style={{ borderColor: "rgba(20,82,97,0.15)" }}
            data-testid={`location-${l.name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div
              className="rounded-[14px] flex items-center justify-center mr-3.5 flex-shrink-0"
              style={{ width: 50, height: 50, background: l.bg }}
            >
              <Icon size={24} color={l.iconColor} strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <p
                className="font-extrabold mb-0.5"
                style={{ color: "#092936", fontSize: 17 }}
              >
                {l.name}
              </p>
              <p
                style={{
                  color: "#5A6A72",
                  fontSize: 13,
                  lineHeight: "18px",
                  whiteSpace: "pre-line",
                }}
              >
                {l.desc}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
